<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <w-flex gap="3">
           <div class="box xs6">
            <template v-if="form.hantar==2">
              <w-input class="mt4" label="Tarikh *" type="date" v-model="form.tarikh" :validators="[validators.required]" outline/>
              <w-input class="mt4" label="Nama *" type="text" v-model="form.nama" readonly :validators="[validators.required]" outline/>
              <w-select class="mt4" :items="lkp_negeri" label="Negeri Mohon" readonly v-model="form.lkp_negeri_id" :validators="[validators.required]" outline/>
            </template>
            <template v-else>
              <table >
                <tbody>
                <tr class="row_data">
                   <td><b>Tarikh</b></td>
                   <td><b>:</b></td>
                   <td>{{ $zutil.dateformat(form.tarikh)}}</td>
                </tr>
                <tr class="row_data">
                   <td><b>Nama</b></td>
                   <td><b>:</b></td>
                   <td>{{form.nama}}</td>
                </tr>
                <tr class="row_data">
                   <td><b>Negeri Mohon</b></td>
                   <td><b> : </b></td>
                   <td>{{form.lkpNegeri_label}}</td>
                </tr>
                </tbody>
              </table>
            </template>
           </div>
        </w-flex><br><br>
        <div class="table-responsive">
          <table class="w-table">
            <thead>
                <tr>
                    <th class="w-table__header w-table__header--sortable text-left" width="1px">Bil</th>
                    <th class="w-table__header w-table__header--sortable text-left">Kuantiti Dimohon</th>
                    <th class="w-table__header w-table__header--sortable text-left">Jenis Ternakan</th>
                    <th class="w-table__header w-table__header--sortable text-left">Jurusan</th>
                    <th class="w-table__header w-table__header--sortable text-left">Baka Ternakan</th>
                    <th class="w-table__header w-table__header--sortable text-left">Tujuan/Justifikasi/Catatan</th>
                    <th class="w-table__header w-table__header--sortable text-left">
                      <w-tooltip md top color="white" bg-color="black" >
                         <template #activator="{ on }">
                               <w-button class="my1" v-on="on" @click="addItem()"><div style="width: 6px"></div> 
                             <w-icon md dark tile class="mr2" >fal fa-plus</w-icon>
                         </w-button>
                         </template>
                        TAMBAH
                     </w-tooltip>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(dt, index) in form.butiran" :key="index">
                    <td class="w-table__cell text-center" width="1px">
                      {{index+1}}
                    </td>
                    <td class="w-table__cell text-center">
                      <w-input class="mt4" placeholder="Sila Masukan Kuantiti" type="number" v-model="dt.kuantiti"/>
                    </td>
                    <td class="w-table__cell text-center">
                      <w-select class="mt4" placeholder="Sila Pilih" :items="lkp_ternakan" v-model="dt.lkp_ternakan_id" @input="getJurusan(dt, dt.lkp_ternakan_id)" :validators="[validators.required]"/>
                    </td>
                    <td class="w-table__cell text-center">
                      <w-select class="mt4" placeholder="Sila Pilih" :items="dt.lkp_jurusan" v-model="dt.lkp_jurusan_id" @input="getBaka(dt, dt.lkp_jurusan_id)" :validators="[validators.required]"/>
                    </td>
                    <td class="w-table__cell text-center">
                      <w-select class="mt4" placeholder="Sila Pilih" :items="dt.lkp_baka" v-model="dt.lkp_baka_id" :validators="[validators.required]"/>
                    </td>
                    <td class="w-table__cell text-center">
                      <w-textarea class="mt4" placeholder="Sila Masukan Catatan"  v-model="dt.catatan"/>
                    </td>
                    <td class="w-table__cell text-center">
                      <w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon>

                    </td>
                </tr>
            </tbody>
          </table>
        </div><br>
        <w-textarea class="mt4" label="Catatan Keseluruhan" v-model="form.catatan" outline/>
        <br>
        <w-flex class="mt3" wrap align-center justify-end>
          <template v-if="$zutil.anyRole(['1', '4'])">
             <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" :loading="form.submitted && !form.sent" v-on="on" @click="send(2); onSuccess()"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-save</w-icon>
                </w-button>
                </template>
               SIMPAN
            </w-tooltip>
            &nbsp;
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" type="submit" v-on="on" bg-color="success" @click="send(1)" :disabled="form.valid === false" :loading="form.submitted && !form.sent"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-paper-plane</w-icon>
                </w-button>
                </template>
               HANTAR
            </w-tooltip>
          </template>
        </w-flex>
      </w-form>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { nextTick } from 'vue';



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_lkp_negeri:[Array, Object],
    d_lkp_ternakan : [Array, Object],
    d_lkp_baka: [Array, Object],
    d_lkp_ternakan: [Array, Object],
    d_lkp_jurusan: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'embrio.permohonan.sttp',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Embrio Beku', route: '/embrio' },
        { label: 'Permohonan', route: '/embrio/permohonan' },
        { label: 'STPP NEGERI', route: '/embrio/permohonan/sttp' },
      ],
      title : ' Permohonan Embrio',
      form : this.d_form,
      lkp_negeri: this.d_lkp_negeri,
      lkp_ternakan: this.d_lkp_ternakan,
      lkp_jurusan: this.d_lkp_jurusan,
      lkp_baka: this.d_lkp_baka,
      lkp_ternakan: this.d_lkp_ternakan,
      
    }
  },
  methods: {
    addItem() {

      this.form.butiran.push({ 
        id:0,
        kuantiti: '', 
        lkp_ternakan_id: '', 
        lkp_jurusan_id:'', 
        lkp_baka_id:'', 
        catatan:'', 
        jenis:'',
        se:'',
        se_permohonan_id:'',
        kuantiti_disetujui:'',
        lkp_status_id:'',
        lkp_jurusan:[],
        lkp_baka:[] });
      // this.form.butiran.push({ id:0,kuantiti: '', lkp_ternakan_id: '', lkp_jurusan_id:'', lkp_baka_id:'', catatan:'', lkp_jurusan:[],lkp_baka:[] });
       console.log(this.form.butiran); 
       this.$nextTick(() => {
    // DOM sudah diupdate, lakukan operasi yang berhubungan dengan DOM disini
  });
    },
    removeItem(index) {
        this.form.butiran.splice(index, 1);
    },
   pilihNoBatch(value){
      for (var i in this.se_katalog) {
         if (this.form.se_katalog_id == this.se_katalog[i].value) {
            // this.form.id_ternakan = this.se_pengeluaran[i].id_ternakan;
            this.form.nama_ternakan = this.se_katalog[i].nama_ternakan;
            this.form.baka = this.se_katalog[i].baka;
            this.form.lkp_negara_id = this.se_katalog[i].lkp_negara_id;
            // this.form.bil_straw = this.se_pengeluaran[i].jumlah_straw;
         }
      }
      // alert('asd');
   },
   getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
      })
    },

    getJurusan(item, i){
      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        item.lkp_jurusan = res;
      })
    },

    getBaka(item,i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        item.lkp_baka = res
      })
    },
    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if (this.form.hantar==1) {
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if (this.form.id > 0) 
          {
            this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
            .then(res => {
              if (typeof this.onAfterEdit === "function") {
                this.onAfterEdit()
              }
              this.$inertia.visit(this.$route('embrio.permohonan.sttp.index'))
              // this.$inertia.visit(this.$route('se.permohonan.sttp.show', this.form.id))
            })
          }
          else 
          {
            this.$zcomm.post(this.resourceurl+'.store' , this.form)
            .then(res => {
              if (typeof this.onAfterAdd === "function") {
                this.onAfterAdd()
              }
              this.$zutil.notify("Berjaya dihantar", true);

              this.$inertia.visit(this.$route('embrio.permohonan.sttp.index'))
              // this.$inertia.visit(this.$route('se.permohonan.sttp.show', res.id))

            })
          }
        }else{ }
        })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('embrio.permohonan.sttp.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
              this.$inertia.visit(this.$route('embrio.permohonan.sttp.form', res.id))
                // this.$inertia.visit(this.$route('se.permohonan.sttp.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
              this.$inertia.visit(this.$route('embrio.permohonan.sttp.form', res.id))
            // this.$inertia.visit(this.$route('se.permohonan.sttp.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      }
    },



    
  
  },

  watch: {

  },
  mounted() {
    if (this.form.id == 0) {
      var today = new Date();
      this.form.tarikh = today.toISOString().split('T')[0];
      this.form.lkp_negeri_id = this.$page.props.auth.user.lkp_negeri_id;
      this.form.user_id = this.$page.props.auth.user.id;
      this.form.nama = this.$page.props.auth.user.name;
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Permohonan Embrio STPP Negeri'
    }
    else
    {
      this.title = 'Tambah Permohonan Embrio STPP Negeri'
    }
   
    this.getTernakan();
    
  }
    
}
</script>
